import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { UnitDetails } from '../../../locums/models/unit-details.model';
import { LocumsJobService } from '../../../locums/services/locums-job.service';
import * as LocumsJobActions from '../actions/job.actions';

@Injectable()
export class LocumsJobEffects {
    constructor(private readonly _actions$: Actions, private readonly _locumsJobService: LocumsJobService) {}

    getUnitDetails$ = createEffect(() =>
        this._actions$.pipe(
            ofType(LocumsJobActions.loadUnitDetails),
            switchMap((action: any) =>
                this._locumsJobService.getUnitDetails(action.jobId).pipe(
                    map((unitDetails: UnitDetails) => LocumsJobActions.loadUnitDetailsSuccess({ unitDetails })),
                    catchError((error) => of(LocumsJobActions.loadUnitDetailsFailure({ error })))
                )
            )
        )
    );
}
